export default __webpack_public_path__ + "static/emenu-presentation_by-3ba771939226a44a65164dc964c564c5.webp";